import Router from 'next/router';
import { useCallback } from 'react';

import { type ClosedImportModalLocation, useTrackClosedImportModal } from '@air/analytics';

import { type ImportOptions } from '~/constants/MenuOptions';
import { Routes } from '~/constants/routes';
import { getPathWithoutQuery } from '~/utils/PathUtils';

type CloseModalProps = {
  location: ClosedImportModalLocation;
};

export const useImportModal = () => {
  const { trackClosedImportModal } = useTrackClosedImportModal();

  const openModal = useCallback((activePage?: ImportOptions) => {
    Router.ready(() => {
      let path = Routes.imports.googleDrive;

      if (activePage) {
        if (activePage === 'import-from-box') {
          path = Routes.imports.homeBox;
        } else if (activePage === 'import-from-dropbox') {
          path = Routes.imports.dropbox;
        } else if (activePage === 'import-from-brandfolder') {
          path = Routes.imports.brandfolder;
        } else if (activePage === 'import-from-canto') {
          path = Routes.imports.canto;
        } else if (activePage === 'import-from-sharePoint') {
          path = Routes.imports.sharePoint;
        } else if (activePage === 'import-from-frameio') {
          path = Routes.imports.frameio;
        }
      }

      Router.push(`${getPathWithoutQuery(Router.asPath)}${path}`, undefined, { shallow: true });
    });
  }, []);

  const closeModal = useCallback(
    ({ location }: CloseModalProps) => {
      Router.ready(() => {
        trackClosedImportModal({ location });

        const [basePath] = Router.asPath.split(Routes.import);

        Router.push(basePath ?? Routes.media.all, undefined, { shallow: true });
      });
    },
    [trackClosedImportModal],
  );

  return {
    openModal,
    closeModal,
  };
};
